import { render, staticRenderFns } from "./BmiGfrWidget.vue?vue&type=template&id=43284ffa&"
import script from "./BmiGfrWidget.vue?vue&type=script&lang=js&"
export * from "./BmiGfrWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports